export default __webpack_public_path__ + "static/media/isb-white.027aec8d.svg";